import { render } from "./CategoryUploadImage.vue?vue&type=template&id=bc474ee4"
import script from "./CategoryUploadImage.vue?vue&type=script&lang=js"
export * from "./CategoryUploadImage.vue?vue&type=script&lang=js"
script.render = render

export default script